//新增页-主合同清单
<template slot="groupTitle">
  <el-form :model="form" ref="formRefs" :rules="rules" label-width="100px">
    <div>
      <div class="btnBox">
        <el-button
          class="btn"
          plain
          type="single-number"
          icon="icon-ccui-add-sup"
          @click="addBrother"
          >新增同级</el-button
        >
        <!-- addCounterpart -->
        <el-button
          class="btn"
          plain
          type="single-number"
          icon="icon-ccui-add-sup"
          @click="AddChildren"
          >新增下级</el-button
        >
        <!-- addSubordinate -->
        <el-button plain type="single-number" @click="handleDelete"
          >删除</el-button
        >
        <!-- deleteTable -->
        <!-- addCounterpart -->
      </div>

      <div>
        <el-table
          v-if="isShow"
          :data="tableData"
          @row-click="selection"
          highlight-current-row
          style="width: 100%; margin-bottom: 20px"
          row-key="positionCode"
          border
          ref="table"
          :load="load"
          lazy
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        >
          <el-table-column
            :show-overflow-tooltip="true"
            label="序号"
            type="index"
            align="center"
          />
          <el-table-column
            :show-overflow-tooltip="true"
            prop="code"
            label="清单编码"
          >
            <template slot-scope="scope">
              <el-checkbox
                v-model="scope.row.check"
                @change="pageCheckEv(scope)"
              ></el-checkbox>
              <el-input
                v-model="scope.row.positionName"
                placeholder="请输入清单编码"
                maxlength="100"
                @change="getblur(scope.row)"
                @blur="check_code(scope.row, $event)"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="remarks"
            label="备注"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.remark"
                placeholder="请输入备注"
                maxlength="50"
                @change="getblur(scope.row)"
              />
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </el-form>
</template>

<script>
// import { createObjectURL } from "ccui/lib/utils/util";
import { addUrlPerFix } from "@/basa/utils";
const baseURL = addUrlPerFix(process.env.VUE_APP_BASE_URL);
import validators from "@/basa/utils/validators";
import BigNumber from "bignumber.js";
// , deleteBill
import {
  addUploadBill,
  addOrEditPosition,
  listBill
} from "../../api/item-edit";

export default {
  name: "materialsManagementInventory",
  props: {
    dataInfo: {
      type: Array
    },
    id: {
      type: String
    }
  },
  computed: {},
  data() {
    return {
      interPostUrl: addUrlPerFix(process.env.VUE_APP_UPLOAD_URL),
      isShow: true,
      maps: new Map(),
      selectedNodes: [],
      newItem: {},
      isLocalData: false,
      parentTreeNode: "",
      tableData: [],
      selectionData: [],
      form: {
        positionCode: "0",
        version: ""
      },
      dialogVisible: false,
      dialogVisibles: false,
      rules: {
        measuringUnit: [
          { required: true, message: "请输入清单单价", trigger: "blur" },
          {
            validator: validators.number,
            message: "请输入正确的清单单价",
            trigger: "blur"
          }
        ]
      },
      dialogImageUrl: "",
      disabled: false,
      selectChange: "",
      fileList: [],
      activeName: "",
      selectChangeList: [], //
      code: 0,
      basuomList: [], //清单单位列表
      iid: 1
    };
  },
  watch: {
    dataInfo() {
      if (this.dataInfo != {}) {
        this.tableData = this.dataInfo;
      }
    },
    tableData: {
      handler(n, o) {
        // let newVal = JSON.parse(JSON.stringify(n))
        this.watchTableData(n);
      },
      deep: true
    }
  },
  created() {
    this.getDict();
    this.getList();
  },
  methods: {
    getSalvar() {
      this.tableData.map(item => {
        item.positionName = item.positionName === "" ? "" : item.positionName;
        item.positionName = item.positionName === "0" ? "" : item.positionName;
      });

      this.addOrEditPosition(this.tableData);
    },
    addOrEditPosition(item) {
      addOrEditPosition({
        list: item,
        ids: this.selectChangeList
      }).then(res => {
        if (res.data.code == 0) {
          this.$message({
            showClose: true,
            message: "保存成功",
            type: "success",
            duration: 3000,
            ccuiCustom: true
          });
          this.getList();
        }
      });
    },
    oninput(num) {
      //      debugger
      //正则替换
      //后来调试发现这个函数只能用于字符串，当是数字的时候就会报此错误
      var str = num.toString();
      str = str.replace(/[^\d.]/g, ""); // 保留数字   /[^\d.]/g, ""
      str = str.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      str = str
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      return str;
    },
    // 监听数组  汇总子级金额 累加
    watchTableData(arr) {
      if (arr.length > 0) {
        arr.forEach(item => {
          if (item.children) {
            // this.watchTableData(item.children);
            if (item.children != []) {
              // for (var i = 0; i < item.children.length; i++) {
              let sum = 0;
              item.children.forEach(val => {
                if (!val.children) {
                  sum += Number(val.amount);
                  if (val.price != "" && val.number != "") {
                    item.price = 0;
                    item.number = 0;
                    if (item.operType === "" || item.operType === 2) {
                      item.operType = 2;
                    } else if (item.operType === 0) {
                      item.operType = 0;
                    }
                  }
                } else {
                  if (item.operType === "" || item.operType === 2) {
                    item.operType = 2;
                  } else if (item.operType === 0) {
                    item.operType = 0;
                  }
                  sum = Number(sum) + Number(val.amount);
                  this.watchTableData(item.children);
                }
              });
              if (item.price == 0 && item.number == 0) {
                item.amount = this.calculateFilter(Number(sum));
              }
              // }
            }
          } else {
            return;
          }
        });
      }
    },
    load(tree, treeNode, resolve) {
      const pid = tree.positionCode;
      // 保存每次展开节点的 tree treeNode（treeData里的一个元素） resolve
      this.maps.set(pid, { tree, treeNode, resolve });
      this.code = tree.positionCode;
      if (treeNode.level >= 0) {
        let obj = { positionCode: tree.positionCode, id: this.id };
        listBill(obj)
          .then(res => {
            if (res.data.code == 0) {
              res.data.data.list.map(item => {
                item.hasChildren = item.isLevel === 0;
              });
              tree.children = res.data.data.list;
              // 把远程数据放入lazyTreeNodeMap
              resolve(res.data.data.list);
            }
          })
          .catch(e => {});
      }
      // this.getList();
    },
    // 查询清单列表
    getList(resolve) {
      // let obj = { code: this.code, positionCode: this.form.positionCode };
    },
    // input change事件 value改变是修改operType状态 0新增 2修改 ""无变化
    getblur(row) {
      if (row.operType === 0) {
        row.operType = 0;
      } else if (row.operType === "" || row.operType === 2) {
        row.operType = 2;
      }
    },
    getDict() {
      //  主合同清单单位字典数据
      // getBasuomDict({})
      //   .then(res => {
      //     this.basuomList = res.data.data;
      //   })
      //   .catch(e => {
      //   });
    },
    addImport() {
      this.dialogVisible = true;
    },
    // 模板下载
    getFileUrls() {
      const obj = "uploadId=" + 10000000054;
      window.location.href =
        baseURL + "/apis/gepma/oss/downloadByUploadId?" + obj;
    },
    cancelRoleInfo() {
      let url, name;
      this.fileList.forEach(item => {
        url = item.downloadUrl;
        name = item.fileName;
      });
      let obj = {
        url: url,
        name: name,
        contractId: this.form.positionCode,
        version: this.form.version
      };
      this.$loading({
        lock: true,
        text: "导入中,请稍后...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      addUploadBill(obj)
        .then(res => {
          this.$loading().close();
          this.$message({
            message: res.data.message,
            type: "success",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
          this.getList();
          this.dialogVisible = false;
          this.fileList = [];
          this.code = 0;
        })
        .catch(e => {
          this.$loading().close();
        });
    },
    selection(item) {
      console.log(item, "当前选择");
      this.selectionData = item;
    },
    watchOpertype(data) {
      data.forEach(item => {
        if (item.children) {
          item.children.forEach(val => {
            if (!val.children) {
              if (item.operType == 2) {
                item.operType = "";
              }
            } else {
              this.watchOpertype(item.children);
            }
          });
        } else {
          return;
        }
      });
    },
    inChange(item) {},
    handleCheckAll(row, checked) {
      row.check = checked;
      if (row.children) {
        let that = this;
        row.children.forEach((element, i) => {
          that.handleCheckAll(row.children[i], checked);
        });
      } else {
        this.$set(row, "check", checked);
      }
    },
    pageCheckEv(scope) {
      // 如果有子项，则子项的选框选择跟当前一致
      if (scope.row.children) {
        this.handleCheckAll(scope.row, scope.row.check);
      }
      this.getSelectionNode(this.tableData);
    },
    // 导入
    importTable() {
      this.dialogVisible = true;
    },
    closeDialog() {
      this.fileList = [];
      this.dialogVisible = false;
    },
    handleRemove(file) {
      file = "";
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {},
    // 表格多选框选中
    handleSelectionChange(val, index) {
      this.selectChange = index.positionCode;
    },
    //文件上传成功的回调函数
    successUpload(response, file, fileList) {
      this.fileList = response.data;
    },
    //文件上传失败的回调函数
    errorUpload(response, file, fileList) {},
    // 验证清单编码格式
    check_code(row, event) {
      // debugger
      var value = row.positionName;
      if (row.positionName === "") {
        let input = event.currentTarget;
        input.style.border = "solid 1px red";
        return this.$message({
          showClose: true,
          message: "请输入清单编码",
          type: "error",
          duration: 3000,
          ccuiCustom: true
        });
      } else {
        let parentCode = row.parentCode;
        let parentName = row.parentName;
        if (parentCode === "") {
          let reg3 = new RegExp("^" + "[A-Za-z0-9]{1,}$");
          if (!reg3.test(value)) {
            // alert('只能正整数');
            // 清单编码只能输入字母、数字及英文的" - ",不能连续输入英文的" - ",并且只能以数字或字母开头
            this.$message({
              showClose: true,
              message:
                "清单编码只能输入字母、数字,并且只能以数字或字母开头,此处格式应为:'" +
                "XXX'",
              type: "error",
              duration: 3000,
              ccuiCustom: true
            });
            let input = event.currentTarget;
            input.style.border = "solid 1px red";
            row.positionName = "";
          } else {
            let index = 0;
            this.tableData.map(item => {
              if (item.positionName === row.positionName) {
                index++;
                if (index > 1) {
                  this.$message({
                    showClose: true,
                    message: "清单编码不能相同",
                    type: "error",
                    duration: 3000,
                    ccuiCustom: true
                  });
                  row.positionName = "";
                }
              }
            });
            let input = event.currentTarget;
            input.style.border = "solid 1px #ccc";
          }
        } else {
          console.log(1111111);
          // debugger;
          const pNodeObj = this.getTreeObjByCode(this.tableData, parentCode);
          let children = pNodeObj.children;
          let index = 0;
          children.map(item => {
            if (item.positionName === row.positionName) {
              index++;
              if (index > 1) {
                this.$message({
                  showClose: true,
                  message: "清单编码不能相同",
                  type: "error",
                  duration: 3000,
                  ccuiCustom: true
                });
                row.positionName = parentName + "-";
              }
            }
          });
          // debugger;
          let reg3 = new RegExp("^" + parentName + "-[A-Za-z0-9]{1,}$");
          if (!reg3.test(value)) {
            // alert('只能正整数');
            // 清单编码只能输入字母、数字及英文的" - ",不能连续输入英文的" - ",并且只能以数字或字母开头
            this.$message({
              showClose: true,
              message:
                "清单编码只能输入字母、数字及英文的' - ',不能连续输入英文的' - ',并且只能以数字或字母开头,此处格式应为:'" +
                parentName +
                "-XXX'",
              type: "error",
              duration: 3000,
              ccuiCustom: true
            });
            let input = event.currentTarget;
            input.style.border = "solid 1px red";
            row.positionName = parentName + "-";
          } else {
            let input = event.currentTarget;
            input.style.border = "solid 1px #ccc";
          }
        }
      }
    },
    // 验证清单名称不能为空
    check_name(row, event) {
      if (row.name == "") {
        let input = event.currentTarget;
        input.style.border = "solid 1px red";
        return this.$message({
          showClose: true,
          message: "请输入清单名称",
          type: "error",
          duration: 3000,
          ccuiCustom: true
        });
      } else {
        let input = event.currentTarget;
        input.style.border = "solid 1px #ccc";
      }
    },
    check_unit(row, event) {
      if (row.operType === 0) {
        row.operType = 0;
      } else if (row.operType === "" || row.operType === 2) {
        row.operType = 2;
      }
      setTimeout(function() {
        if (row.unit == "") {
          // let input = event.currentTarget;
          event.target.style.border = "solid 1px red";
          this.$message({
            showClose: true,
            message: "请输入清单单位",
            type: "error",
            duration: 3000,
            ccuiCustom: true
          });
        } else {
          // let input = event.currentTarget;
          event.target.style.border = "solid 1px #ccc";
        }
      }, 100);
    },
    // 校验清单单价
    check_price(row, event) {
      if (row.price == "") {
        let input = event.currentTarget;
        input.style.border = "solid 1px red";
        this.$message({
          showClose: true,
          message: "请输入清单单价",
          type: "error",
          duration: 3000,
          ccuiCustom: true
        });
      } else {
        let input = event.currentTarget;
        input.style.border = "solid 1px #ccc";
        row.price = this.calculateFilter(row.price);
        if (row.number != "") {
          this.$set(
            row,
            "amount",
            this.calculateFilter(
              // multipliedBy 乘法
              new BigNumber(Number(row.price)).multipliedBy(Number(row.number))
            )
          );
        }
      }
    },
    // input 失焦事件 计算清单金额 // 校验清单数量
    check_number(row, event) {
      if (row.number == "") {
        let input = event.currentTarget;
        input.style.border = "solid 1px red";
        this.$message({
          showClose: true,
          message: "请输入清单数量",
          type: "error",
          duration: 3000,
          ccuiCustom: true
        });
      } else {
        // row.number = Number(row.number).toFixed(3);
        if (row.number) {
          if (Number(row.number) > 100000000) {
            let number = Number((row.number + "").substring(0, 8));
            this.$set(row, "number", number);
          }
          if ((row.number + "").split("").length > 1) {
            if ((row.number + "").split("")[0] == 0) {
              if (Number((row.number + "").split("")[1]) >= 0) {
                this.$set(
                  row,
                  "number",
                  Number((row.number + "").split("")[0])
                );
              }
            }
          }
          if ((row.number + "").indexOf(".") != -1) {
            if ((row.number + "").split(".")[1] != "") {
              let number = Number(
                (row.number + "").substring(
                  0,
                  (row.number + "").indexOf(".") + 4
                )
              );
              this.$set(row, "number", number);
            }
          }
        }
        let input = event.currentTarget;
        input.style.border = "solid 1px #ccc";
        row.number = this.numberFilter(row.number);
        if (row.price != "") {
          this.$set(
            row,
            "amount",
            this.calculateFilter(
              // multipliedBy 乘法
              new BigNumber(Number(row.price)).multipliedBy(Number(row.number))
            )
          );
        }
      }
    },
    // 金额四舍五入
    calculateFilter(data) {
      if (data || data == 0) {
        if ((data + "").indexOf(".") != -1) {
          let newData = (data + "").substring(0, (data + "").indexOf(".") + 9);
          return newData;
        } else {
          return data;
        }
      } else {
        return "";
      }
    },
    // 数量四舍五入
    numberFilter(data) {
      if (data || data == 0) {
        if ((data + "").indexOf(".") != -1) {
          let newData = (data + "").substring(0, (data + "").indexOf(".") + 4);
          return newData;
        } else {
          return data;
        }
      } else {
        return "";
      }
    },

    changeStatus(treeData, node) {
      const arr = treeData;
      const len = arr.length;
      const lop = function() {
        for (let i = 0; i < len; i++) {
          if (treeData[i].positionCode === node.positionName) {
            // debugger;
          }
          if (arr[i].childern) {
            lop(arr[i].childern);
          }
        }
      };
      lop(node);
    },
    getTreeObjByCode(arr, code) {
      let obj = {};
      const recursion = arr => {
        for (var i = 0; i < arr.length; i++) {
          // debugger
          if (arr[i].children && arr[i].children.length !== 0) {
            // 有children且children的长度大于0
            // 获取当前菜单
            // debugger;
            if (arr[i].positionCode === code) {
              obj = arr[i];
              break;
            }
            // 递归遍历
            recursion(arr[i].children);
          } else {
            // 没有childer或children的length为0
          }
        }
      };
      recursion(arr);
      return obj;
    },
    handleDelete() {
      if (this.selectedNodes.length) {
        // 对this.selectedNodes里的节点的所有父节点进行更新。
        this.updateParentNodes(this.selectedNodes);
        // this.selectedNodes里面的节点不必先去掉被删除节点的子节点，见this.deleteTreeNode里的空对象{}判断处理。
        this.selectedNodes.forEach(item => {
          this.deleteTreeNode(item);
        });
        this.selectedNodes = [];
      } else {
        this.$message({
          message: "请先选择要删除的节点",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      }
    },
    updateParentNodes(selectedNodes) {
      // 获取待删除节点的所有路径节点Code map
      const set = new Set();
      selectedNodes.forEach(item => {
        let arr = item.positionCode.split("-");
        let str = "";
        arr.forEach(subItem => {
          str += str === "" ? subItem : "-" + subItem;
          set.add(str);
        });
      });

      // 获取所有要更新的父节点
      // 遍历所有节点
      let arr = this.tableData;
      const recursion = arr => {
        for (var i = 0; i < arr.length; i++) {
          // debugger
          if (set.has(arr[i].positionCode) && arr[i].positionCode) {
            arr[i].operType = "2";
          } else {
            arr[i].operType = arr[i].operType === 0 ? arr[i].operType : "";
          }
          if (arr[i].children && arr[i].children.length !== 0) {
            // 有children且children的长度大于0
            // 递归遍历
            recursion(arr[i].children);
          } else {
            // 没有childer或children的length为0
          }
        }
      };
      recursion(arr);
    },
    deleteTreeNode(obj) {
      const store = this.$refs.table.store;
      const treeData = store.states.treeData;
      // 选择元素的id
      const selectionId = obj.positionCode;
      // 选择元素的父级节点code
      const positionName = obj.parentCode;
      const lazyTreeNodeMap = store.states.lazyTreeNodeMap;

      // 父元素是否本地元素
      this.isLocalData = !this.maps.has(positionName);
      if (this.isLocalData) {
        // 1.操作本地数据
        // debugger;

        let index = this.tableData.findIndex(
          item => item.positionCode === obj.positionCode
        );
        if (index !== -1) {
          // 1。1 操作第一层本地数据
          this.tableData.splice(index, 1);
          // 1。2记录要删除数据的code
          if (obj.positionCode) {
            this.selectChangeList.push(obj.id);
          }
        } else {
          // 1。2操作多层数据
          // 1。2。1获取被删除节点的父节点
          // debugger;
          const pNodeObj = this.getTreeObjByCode(this.tableData, positionName);
          if (pNodeObj.positionCode) {
            // 1。2。1。1 如果存在父节点，执行删除，如果不存在父节点也就是返回空对象{}，说明在之前的删除操作中父节点已经被删除
            let key = pNodeObj.positionCode;
            let subKey = selectionId;
            let index = pNodeObj.children.findIndex(
              item => item.positionCode === selectionId
            );
            const arr = JSON.parse(JSON.stringify(pNodeObj.children));
            arr.splice(index, 1);
            if (!arr.length) {
              pNodeObj.hasChildren = false;
              pNodeObj.isLeaf = 1;
              // 如果length为0则不展开
              treeData[key].expanded = false;
            }
            treeData[key].loading = false;
            treeData[key].loaded = true;

            delete treeData[subKey];
            this.$delete(lazyTreeNodeMap, key);
            this.$set(pNodeObj, "children", arr);
          }
        }
      } else {
        // 2.操作远程数据
        // const { tree, treeNode, resolve } = this.maps.get(positionName); // tree 父节点
        const { tree } = this.maps.get(positionName); // tree 父节点
        // 父节点id
        const parentNodeId = tree.positionCode;
        // debugger;
        let len = treeData[parentNodeId].children.length;
        if (len === 1) {
          //2.1删除节点没有兄弟节点
          // 获取当前要删除的节点对象
          this.getItemFromTreeObj(this.tableData, selectionId);
          this.$delete(lazyTreeNodeMap, parentNodeId);
          this.$delete(treeData, parentNodeId);
          //
          this.$delete(tree, "children");
          tree.hasChildren = false;
          if (obj.positionCode) {
            this.selectChangeList.push(this.selectionData.id);
          }
        } else {
          //2.2删除节点有兄弟节点
          const arr = [];
          // let key;
          let keyArr = [];
          tree.children.forEach((item, i) => {
            if (item.positionCode === selectionId) {
              // debugger
              if (item.positionCode) {
                this.selectChangeList.push(item.id);
              }
            } else {
              arr.push(item);
              keyArr.push(item.positionCode);
            }
          });
          this.$set(lazyTreeNodeMap, parentNodeId, arr);
          //
          // debugger;
          this.$set(tree, "children", arr);
          //
          this.$set(treeData[parentNodeId], "children", keyArr);
        }
      }
      obj = {};
      this.selectionData = [];
    },
    genNewData(type = "child") {
      const data = this.selectionData;
      let code, positionName, parentCode, parentName;
      switch (type) {
        case "child": {
          positionName =
            data.positionName !== "" ? data.positionName + "-" + "" : "";
          parentCode = data.positionCode ? data.positionCode : "";
          parentName = data.positionName;
          break;
        }
        case "brother": {
          // debugger;
          if (data.positionName) {
            const arr = data.positionName.split("-");
            let len = arr.length;
            if (len > 1) {
              arr.length = len - 1;
              const str = arr.join("-");
              positionName = data.parentName !== "" ? str + "-" + "" : "";
              parentCode = data.parentCode ? data.parentCode : "";
              parentName = data.parentName;
            } else {
              parentName = "";
              parentCode = "";
            }
          } else {
            // 新增
            code = "";
            positionName = "";
            parentCode = data.positionCode ? data.positionCode : "";
          }
        }
      }
      const obj = {
        positionCode: new Date().getTime() + "", // 保证id为字符串类型
        code: code,
        name: "",
        unit: "",
        price: "",
        number: "",
        amount: "",
        remark: "",
        isLeaf: "1",
        hasChildren: false,
        id: "",
        positionName: positionName,
        parentCode: parentCode,
        parentName: parentName,
        check: false,
        operType: 0 // 操作类型新增0，修改2 无操作时为空
      };
      // debugger;
      return Object.assign({}, obj);
    },
    getItemFromTreeObj(treeObj, positionCode) {
      var traverse = treeObj => {
        for (var i = 0; i < treeObj.length; i++) {
          if (treeObj[i] && treeObj[i].positionCode === positionCode) {
            // 获取该节点
            this.parentTreeNode = treeObj[i];
          }
          if (
            treeObj[i] &&
            treeObj[i].children &&
            treeObj[i].children.length !== 0
          ) {
            traverse(treeObj[i].children);
          }
          // else {
          //   if (treeObj[i].positionCode === positionCode) {
          //     // 获取当前菜单的父菜单
          //     that.currentMenuObj = treeObj[i];
          //     that.setParentMenu(that.menu, treeObj[i].pid, treeObj[i].positionCode);
          //   }
          // }
        }
      };

      traverse(treeObj);
    },
    myLoad(key, data) {
      this.$set(this.$refs.table.store.states.lazyTreeNodeMap, key, data);
    },

    getSelectionNode(arr) {
      const selectedNodeArr = [];
      // debugger;
      const recursion = arr => {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i].check === true) {
            // 不论是否有billCode都放入数组
            selectedNodeArr.push(arr[i]);
          }
          if (arr[i].children && arr[i].children.length !== 0) {
            // 有children且children的长度大于0
            // 递归遍历
            recursion(arr[i].children);
          } else {
            // 没有childer或children的length为0
          }
        }
      };
      recursion(arr);
      this.selectedNodes = selectedNodeArr;
    },
    // 树形表格参考代码
    deleteItem(scope) {
      const item = scope.row;
      this.$confirm(
        this.$t("app.common.message.deleteWarningMessage", { 0: "" })
      ).then(async result => {
        if (!result) {
          return;
        }
        // 删除接口，根据自己项目相应处理
        await this.api.deleteItem({ positionCode: item.positionCode });
        this.deleteLazyTableItem(item);
        this.$message.success(
          this.$t("app.common.message.successfullyDeleted")
        );
      });
    },
    addBrother(selectedNodeObj, type = "brother") {
      selectedNodeObj = selectedNodeObj.positionCode
        ? selectedNodeObj
        : this.selectionData.length === 0
        ? { isLevel: 0 }
        : this.selectionData;
      // this.isAdding = true;
      const store = this.$refs.table.store;
      const treeData = store.states.treeData;
      // debugger;
      const lazyTreeNodeMap = store.states.lazyTreeNodeMap;
      this.isLocalData = !this.maps.has(selectedNodeObj.isLevel);
      this.newItem = this.genNewData(type);
      // debugger;
      if (selectedNodeObj)
        if (this.isLocalData) {
          // 1 编辑本地数据
          // debugger;
          if (
            selectedNodeObj.isLevel === 0 ||
            selectedNodeObj.parentCode === "" ||
            selectedNodeObj.parentCode === ""
          ) {
            // 1.1一级树加同级节点
            this.newItem.positionName = "";
            this.newItem.parentCode = "";
            this.newItem.parentName = "";
            this.tableData.push(this.newItem);
          } else {
            // 1.2一级以外树加同级节点
            // 1.2.1 获取父节点
            if (this.tableData.length) {
              if (!this.selectionData.positionCode) {
                this.$message({
                  message: "请先选中兄弟节点",
                  type: "error",
                  duration: 3000,
                  showClose: true,
                  ccuiCustom: true
                });
                return;
              }
              const pTreeNodeObj = this.getTreeObjByCode(
                this.tableData,
                selectedNodeObj.parentCode
              );
              // 把新增节点加载父节点
              // 1。1 没有子节点
              // debugger;
              let key = pTreeNodeObj.positionCode;
              let subKey = this.newItem.positionCode;
              treeData[key] = {};
              treeData[key].loading = false;
              treeData[key].loaded = true;
              treeData[key].expanded = true;
              treeData[subKey] = {};
              treeData[subKey].loading = false;
              treeData[subKey].loaded = false;
              treeData[subKey].expanded = false;
              if (lazyTreeNodeMap) {
                lazyTreeNodeMap[key].push(this.newItem);
                this.$set(lazyTreeNodeMap, key, lazyTreeNodeMap[key]);
              }
              if (pTreeNodeObj.children.indexOf(this.newItem) === -1) {
                pTreeNodeObj.children.push(this.newItem);
              }
              // this.$set(pTreeNodeObj, "children", []);
              this.$set(pTreeNodeObj, "children", pTreeNodeObj.children);
            } else {
              this.tableData.push(this.newItem);
            }
          }
        } else {
          // 2 编辑懒加载数据
          let positionName, arr;
          positionName = selectedNodeObj.positionName;
          let { tree, resolve } = this.maps.get(positionName);
          arr = JSON.parse(JSON.stringify(tree.children));
          arr.push(this.newItem);
          this.$set(tree, "children", arr);
          resolve(arr);
        }
    },
    AddChildren() {
      if (!this.selectionData.positionCode) {
        this.$message({
          message: "请先选中父节点",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        return;
      }

      if (!this.selectionData.positionName) {
        this.$message({
          message: "请先完善父节点信息",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        return;
      }
      if (this.selectionData.parentName !== "") {
        let reg3 = new RegExp(
          "^" + this.selectionData.parentName + "-[A-Za-z0-9]{1,}$"
        );
        if (!reg3.test(this.selectionData.positionName)) {
          // alert('只能正整数');
          // 清单编码只能输入字母、数字及英文的" - ",不能连续输入英文的" - ",并且只能以数字或字母开头
          this.$message({
            showClose: true,
            message:
              "清单编码只能输入字母、数字及英文的' - ',不能连续输入英文的' - '",
            type: "error",
            duration: 3000,
            ccuiCustom: true
          });
          return;
        }
      }
      const store = this.$refs.table.store;
      const treeData = store.states.treeData;
      const parentId = this.selectionData.positionCode;
      const lazyTreeNodeMap = store.states.lazyTreeNodeMap;
      this.isLocalData = !this.maps.has(this.selectionData.positionName);
      this.newItem = this.genNewData();
      // debugger;
      if (this.isLocalData) {
        // 1 编辑本地数据
        // debugger;
        this.getItemFromTreeObj(this.tableData, parentId);
        const parentTreeNode = this.parentTreeNode;
        // this.isAddWithoutBrother = !parentTreeNode.hasChildren;
        if (!parentTreeNode.hasChildren) {
          // 1。1 没有子节点
          if (parentTreeNode.positionName !== "") {
            // debugger;
            let key = this.selectionData.positionCode;
            let subKey = this.newItem.positionCode;
            treeData[key] = {};
            treeData[key].loading = false;
            treeData[key].loaded = true;
            treeData[key].expanded = true;
            treeData[subKey] = {};
            treeData[subKey].loading = false;
            treeData[subKey].loaded = false;
            treeData[subKey].expanded = false;
            this.$set(lazyTreeNodeMap, key, [this.newItem]);
            this.selectionData.hasChildren = true;
            this.selectionData.isLeaf = 0;
            this.$set(this.selectionData, "children", [this.newItem]);
          } else {
            this.$message({
              message: "请先完善本级再增加下级",
              type: "error",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
          }
        } else {
          // 1。2 已有子节点
          // 1。2。1 获取其中一个子节点(第一个)
          // this.selectionData = this.selectionData.children[0];
          this.addBrother(this.selectionData.children[0], "child");
        }
      } else {
        // 2 编辑懒加载数据
        // let positionName;
        if (this.selectionData.hasChildren) {
          // 2。1选中元素有子节点
          // debugger;
          if (
            this.selectionData.children &&
            this.selectionData.children.length
          ) {
            let key = this.selectionData.positionCode;
            let keyArr = lazyTreeNodeMap[key];
            keyArr.push(this.newItem);
            this.$set(lazyTreeNodeMap, key, keyArr);
          } else {
            this.$message({
              message: "请先展开选中节点再增加下级",
              type: "error",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
          }
        } else {
          // 2.2 选中元素没有子节点
          // debugger;
          let key = this.selectionData.positionCode;
          let subKey = this.newItem.positionCode;
          // let positionName = this.selectionData.positionName;
          treeData[key] = {};
          treeData[key].loading = false;
          treeData[key].loaded = true;
          treeData[key].expanded = true;
          treeData[subKey] = {};
          treeData[subKey].loading = false;
          treeData[subKey].loaded = false;
          treeData[subKey].expanded = false;
          this.$set(lazyTreeNodeMap, key, [this.newItem]);
          this.selectionData.hasChildren = true;
          this.$set(this.selectionData, "children", [this.newItem]);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.dialog-center {
  background: #767676;
}
/deep/.dialog-center .el-dialog {
  width: 444px;
  background: #ffffff;
  border-radius: 2px;
}
.el-dialog-box {
  display: inline-block;
  width: 276px;
  height: 90px;
  border-radius: 4px;
  border: 1px solid #cccccc;
}
/deep/.el-upload {
  margin: 10px 11px;
  width: 56px;
  height: 70px;
  border-radius: 4px;
  border: 1px solid #cccccc;
}

/deep/.el-dialog__title {
  margin: 10px 0;
  display: inline-block;
}
/deep/.el-dialog__body {
  height: 155px;
  padding-top: 20px;
  box-sizing: border-box;
}
/deep/.el-form-item__label {
  width: 105px;
}
/deep/.el-dialog-upload {
  padding-right: 20px;
  text-align: right;
  height: 17px;
  font-size: 12px;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 400;
  color: #4a4a4a;
  line-height: 17px;
}
.el-dialog__body .el-form .el-form-item {
  margin-bottom: 5px;
}
/deep/.el-textarea {
  width: 276px !important;
  height: 90px;
}
/deep/.ccui-form {
  margin-top: 0;
}
/deep/.group-content {
  margin-top: 0;
  padding: 0 20px;
}
.extend-btn {
  text-align: right;
  margin-bottom: 20px;
}
.materials-management-inventory {
  padding-bottom: 20px;
  position: relative;
}
/deep/.el-table .el-table__body-wrapper .el-table__body tr td {
  width: 203px;
  height: 36px;
  border: 1px solid #f2f2f2;
  padding: 0;
}
.el-input /deep/ input.el-input__inner {
  height: 26px;
  background: #f1f1f1;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #9b9b9b;
}
.btnBox {
  text-align: right;
  margin-bottom: 20px;
}

/deep/.btn span {
  margin-left: 6px;
}
/deep/.btn i {
  top: 8px !important;
}

/deep/.el-table__row--level-1 td:nth-child(2) .cell .el-table__indent {
  padding-left: 10px;
}
/deep/.el-checkbox {
  margin-right: 10px;
}
/deep/.el-table__row td:nth-child(2) .cell .el-input .el-input__inner {
  width: 159px;
}
/deep/.el-table__row--level-0 td:nth-child(2) .cell .el-input .el-input__inner {
  width: 159px;
}

/deep/.el-table__row td:nth-child(4) .cell .el-select {
  width: 100%;
}
/deep/.el-select .el-input__inner {
  background: #f1f1f1;
}

.el-dialog-upload > span {
  color: #0089ef;
  cursor: pointer;
}
</style>
